// extracted by mini-css-extract-plugin
module.exports = {"buttonsArea":"widget-demo--buttonsArea--1Blro","fileInput":"widget-demo--fileInput--XZ2iz"};